import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ConcorrenteSelectModule } from '../../../../domains/shared/components/concorrente-select/concorrente-select.module';

import { ClienteConcorrenteComponent } from './cliente-concorrente.component';

@NgModule({
    imports: [
        SharedModule,
        ConcorrenteSelectModule
    ],
    declarations: [
        ClienteConcorrenteComponent
    ],
    exports: [
        ClienteConcorrenteComponent
    ]
})
export class ClienteConcorrenteModule { }
